<script setup lang="ts">
import { setErrors, clearErrors } from '@formkit/core'
const { t } = useI18n()

interface Props {
  redirect?: string
}

interface Submit {
  username: string,
  password: string
}

const { redirect = '/u/moje-konto' } = defineProps<Props>()

const { signIn } = useAuth()
const submit = async (data: Submit) => {
  clearErrors('login-form')
  try {
    await signIn({
      username: data.username,
      password: data.password,
    }, {
      callbackUrl: redirect
    })
  } catch (e) {
    setErrors(
      'login-form',
      e.data.data.errors.map(({ detail }) => t(detail))
    )
  }
}
</script>

<template>
  <FormKit
    type="form"
    id="login-form"
    :actions="false"
    :incomplete-message="false"
    @submit="submit"
  >
    <FormKit
      type="email"
      outer-class="mb-[10px]"
      name="username"
      label="E-mail*"
      placeholder="E-mail*"
      validation="required"
      validation-visibility="blur"
      :validation-messages="{
        required: 'Pole e-mail nie może być puste.'
      }"
    />
    <FormKit
      type="password"
      outer-class="mb-[10px]"
      name="password"
      label="Hasło*"
      placeholder="Hasło*"
      validation="required"
      validation-visibility="blur"
      :validation-messages="{
        required: 'Pole hasło nie może być puste.'
      }"
    />
    <div class="text-gray-500 text-12">
      * Pole wymagane
    </div>
    <FormKit
      type="submit"
      input-class="btn btn-action btn-lg mb-[10px]"
    >
      <span class="text-16">Przejdź do konta</span>
      <i class="icon-arrow-button text-[10px]" />
    </FormKit>
  </FormKit>
</template>
